import React from 'react';

const LOOKBACK_LABELS = {
  general_pricing_days: { label: 'General Pricing', unit: 'days' },
  booking_velocity_hours: { label: 'Booking Velocity', unit: 'hours' },
  price_elasticity_days: { label: 'Price Elasticity', unit: 'days' },
  cancellation_rate_days: { label: 'Cancellation Rate', unit: 'days' },
  conversion_rate_days: { label: 'Conversion Rate', unit: 'days' },
  discount_effectiveness_days: { label: 'Discount Effectiveness', unit: 'days' },
  search_lead_time_days: { label: 'Search Lead Time', unit: 'days' },
};

export default function LookbackConfigCard({ lookbackConfig, presets, onPresetChange, onChange }) {
  const [expanded, setExpanded] = React.useState(false);

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">Historical Data Lookback</h3>
        <div className="flex items-center gap-2">
          <select
            value={lookbackConfig?.preset || 'default'}
            onChange={(e) => onPresetChange(e.target.value)}
            className="text-sm border rounded px-2 py-1"
          >
            {presets && Object.entries(presets).map(([key, preset]) => (
              <option key={key} value={key}>{preset.label}</option>
            ))}
            <option value="custom">Custom</option>
          </select>
          <button
            onClick={() => setExpanded(!expanded)}
            className="text-sm text-blue-600 hover:text-blue-800"
          >
            {expanded ? 'Collapse' : 'Expand'}
          </button>
        </div>
      </div>

      {expanded && (
        <div className="grid grid-cols-2 gap-4 mt-4">
          {Object.entries(LOOKBACK_LABELS).map(([key, { label, unit }]) => (
            <div key={key}>
              <label className="block text-sm text-gray-600 mb-1">{label}</label>
              <div className="flex items-center gap-2">
                <input
                  type="number"
                  value={lookbackConfig?.[key] || 0}
                  onChange={(e) => onChange({ [key]: parseInt(e.target.value) || 0 })}
                  className="w-20 border rounded px-2 py-1 text-sm"
                />
                <span className="text-sm text-gray-500">{unit}</span>
              </div>
            </div>
          ))}
        </div>
      )}

      {!expanded && (
        <p className="text-sm text-gray-500">
          Using {lookbackConfig?.preset || 'default'} preset. Click expand to customize.
        </p>
      )}
    </div>
  );
}
